import * as React from 'react';
import { Button } from '@cian/ui-kit';
import * as styles from './MobileFiltersPopup.css';
import { Modal } from '../../../Modal';

interface IMobileFiltersPopupProps {
  open: boolean;
  onClose?(): void;
  onClear?(): void;
  onSubmit?(): void;
}

export const MobileFiltersPopup: React.FC<React.PropsWithChildren<IMobileFiltersPopupProps>> = ({
  children,
  open,
  onClear,
  onClose,
  onSubmit,
}) => {
  return (
    <Modal
      name="FiltersModal"
      open={open}
      onClose={onClose}
      title="Фильтры"
      footer={
        <div className={styles['footer']}>
          <Button aria-label="Сбросить фильтр" size="L" theme="fill_secondary" onClick={onClear}>
            Сбросить
          </Button>
          <Button aria-label="Показать посёлки" size="L" onClick={onSubmit}>
            Показать посёлки
          </Button>
        </div>
      }
    >
      <div className={styles['content']}>{children}</div>
    </Modal>
  );
};
